export { LabResultsNavigation } from './LabResultsNavigation';
